import { Form, Space, Col, Popover, Switch, TableColumnType } from "antd";
import moment from "moment";
import React from "react";
import { BillingCategoryName } from "../../../models/billingCategory";
import { DateTimeFormat, DateTimeFormatSimple } from "../../../models/datetime";
import { Dimen } from "../../../models/dimen";
import { ColDef } from "ag-grid-community";
import styles from './recardDurg.module.css'

export const RecardDrugColumns = (
  startIndex: number,
  receiptDetail: (id:any) => void
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      align: 'center',
      width: Dimen.Num,
      key: 'no',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '业务单号',
      align: 'center',
      dataIndex: 'putNumber',
      width: Dimen.Coding,
      key: 'putNumber',
      render: function Element(_, record) {
        return (
          <a onClick={() => {
            receiptDetail(record.tenantInventoryReceiptId)
          }} style={{cursor: 'pointer',width:'100%',height:'100%',alignItems: 'center',display: 'flex',margin:'auto'}}> {record.putNumber} </a>
        );
      }
    },
    {
      title: '商品编码',
      align: 'center',
      dataIndex: 'no',
      width: Dimen.Coding,
      key: 'no',
    },
    {
      title: '产品信息',
      align: 'left',
      width: '300px',
      dataIndex: 'producInfo',
      key: 'producInfo',
      render: function Element(_, record) {
        return (
          <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Col>
              <Popover
                content={
                  <div style={{ height: '55px' }}>
                    <p
                      style={{
                        height: '28px',
                        lineHeight: '36px',
                        padding: '0',
                        margin: '0',
                        fontSize: '16px',
                        fontWeight: 'bolder',
                      }}
                    >
                      {record.name}
                    </p>
                    <p
                      style={{
                        height: '28px',
                        lineHeight: '24px',
                        padding: '0',
                        margin: '0',
                        color: '#999999',
                        fontSize: '14px',
                      }}
                    >
                      {record.tenantSupplierName} /{' '}
                      {record.packSpec ? record.packSpec : '暂无'} /
                      {record.doseCategory}
                    </p>
                  </div>
                }
                placement='bottom'
              >
                <div
                  style={{ height: '55px', width: '300px', overflow: 'hidden' }}
                >
                  <p
                    style={{
                      height: '28px',
                      lineHeight: '36px',
                      padding: '0',
                      margin: '0',
                      fontSize: '16px',
                      fontWeight: 'bolder',
                    }}
                  >
                    {record.name}
                  </p>
                  <p
                    style={{
                      height: '28px',
                      lineHeight: '24px',
                      padding: '0',
                      margin: '0',
                      color: '#999999',
                      fontSize: '14px',
                    }}
                  >
                    {record.tenantSupplierName} /{' '}
                    {record.packSpec ? record.packSpec : '暂无'} /
                    {record.doseCategory}
                  </p>
                </div>
              </Popover>
            </Col>
          </Space>
        )
      },
    },
    {
      title: '制剂规格',
      align: 'center',
      width: Dimen.ApprovalNumber,
      dataIndex: 'spec',
      key: 'spec',
    },
    {
      title: '剂型',
      align: 'center',
      width: Dimen.ApprovalNumber,
      dataIndex: 'doseCategory',
      key: 'doseCategory',
    },
    {
      title: '通用名',
      align: 'center',
      width: Dimen.ApprovalNumber,
      dataIndex: 'genericName',
      key: 'genericName',
    },
    {
      title: '产地',
      align: 'center',
      width: Dimen.ApprovalNumber,
      dataIndex: 'origin',
      key: 'origin',
    },
    {
      title: '医保国码',
      align: 'center',
      width: Dimen.ApprovalNumber,
      dataIndex: 'hilistCode',
      key: 'hilistCode',
    },
    {
      title: '批次号',
      align: 'center',
      width: Dimen.ApprovalNumber,
      dataIndex: 'batchNo',
      key: 'batchNo',
    },
    {
      title: '批准文号',
      align: 'center',
      width: Dimen.ApprovalNumber,
      dataIndex: 'approvalNumber',
      key: 'approvalNumber',
    },
    {
      title: '库房名称',
      align: 'center',
      width: Dimen.Name,
      dataIndex: 'storehouseName',
      key: 'storehouseName',
    },
    {
      title: '生产日期',
      align: 'center',
      width: Dimen.Time,
      dataIndex: 'productDate',
      key: 'productDate',
      render: (_: any, t: any) => {
        return t.productDate
          ? moment(t.productDate).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '有效期至',
      align: 'center',
      width: Dimen.Time,
      dataIndex: 'deadline',
      key: 'deadline',
      render: (_: any, t: any) => {
        return t.deadline
          ? moment(t.deadline).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '进价',
      align: 'right',
      width: Dimen.Price,
      dataIndex: 'unitPrice',
      key: 'unitPrice',
      render: (_: any, t: any) => {
        return t.unitPrice
          ? parseFloat((t.unitPrice as unknown) as string).toFixed(5)
          : 0
      },
    },
    {
      title: '销售价',
      align: 'center',
      width: Dimen.Price,
      dataIndex: 'retailPrice',
      key: 'retailPrice',
      render: (_: any, t: any) => {
        return t.retailPrice
          ? parseFloat((t.retailPrice as unknown) as string).toFixed(5)
          : 0
      },
    },
    {
      title: '采购数量',
      align: 'center',
      width: Dimen.Count,
      dataIndex: 'count',
      key: 'count',
      render: function Element(_: any, t: any) {
        return <><span>{t.count}</span><span>{t.unit}</span></>
      },
    },
    {
      title: '变动金额(进价)',
      align: 'right',
      width: Dimen.Price,
      dataIndex: '',
      key: '',
      render: (_: any, t: any) => {
        return t.unitPrice * t.count
          ? parseFloat(((t.unitPrice * t.count) as unknown) as string).toFixed(
              2
            )
          : 0
      },
    },
    {
      title: '供应商',
      align: 'center',
      width: Dimen.SupplierName,
      dataIndex: 'supplierName',
      key: 'supplierName',
    },
    {
      title: '采购时间',
      align: 'center',
      width: Dimen.Time,
      dataIndex: 'recepitsDate',
      key: 'recepitsDate',
      render: (_: any, t: any) => {
        return t.recepitsDate
          ? moment(t.recepitsDate).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '采购人员',
      align: 'center',
      width: Dimen.Name,
      dataIndex: 'userName',
      key: 'userName',
    },
  ]
};

export const AGColumns = (
  startIndex?: any,
  receiptDetail?: (id: any) => void,
  columnList?: any,
  cell?: any,
  KFGZZCKLRSJData?: any,
): ColDef[] => {

  return (
    columnList?.map((item: any) => {
      // 根据注释掉的列配置，补充 cellRendererFramework 或 valueFormatter
      switch (item.field) {
        case 'index':
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) {
                return ''
              }
              return `${Number(startIndex || 0) + params.node.rowIndex + 1}`
            },
          };
        case 'putNumber': // 业务单号
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: function getPutNumber(params: any) {
              const record = params.data;
              if (params.node.rowPinned) return '';
              return (
                <a onClick={() => {
                  receiptDetail && receiptDetail(record.tenantInventoryReceiptId)
                }} style={{ cursor: 'pointer', width: '100%', height: '100%', alignItems: 'center', display: 'flex', margin: 'auto' }}> {record.putNumber} </a>
              );
            }
          };
        case 'producInfo': //产品信息
          return {
            ...item,
            headerClass: styles.leftAligned,
            cellStyle: { textAlign: 'left' },
            cellRendererFramework: function getProducInfo(params: any) {
              const record = params.data;
              if (params.node.rowPinned) return '合计';
              return <Space style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Col>
                  <Popover
                    content={
                      <div style={{ height: '55px' }}>
                        <p
                          style={{
                            height: '28px',
                            lineHeight: '36px',
                            padding: '0',
                            margin: '0',
                            fontSize: '16px',
                            fontWeight: 'bolder',
                          }}
                        >
                          {record.name}
                        </p>
                        <p
                          style={{
                            height: '28px',
                            lineHeight: '24px',
                            padding: '0',
                            margin: '0',
                            color: '#999999',
                            fontSize: '14px',
                          }}
                        >
                          {record.tenantSupplierName} /{' '}
                          {record.packSpec ? record.packSpec : '暂无'} /
                          {record.doseCategory}
                        </p>
                      </div>
                    }
                    placement='bottom'
                  >
                    <div
                      style={{ height: '55px', width: '300px', overflow: 'hidden' }}
                    >
                      <p
                        style={{
                          height: '28px',
                          lineHeight: '36px',
                          padding: '0',
                          margin: '0',
                          fontSize: '16px',
                          fontWeight: 'bolder',
                        }}
                      >
                        {record.name}
                      </p>
                      <p
                        style={{
                          height: '28px',
                          lineHeight: '24px',
                          padding: '0',
                          margin: '0',
                          color: '#999999',
                          fontSize: '14px',
                        }}
                      >
                        {record.tenantSupplierName} /{' '}
                        {record.packSpec ? record.packSpec : '暂无'} /
                        {record.doseCategory}
                      </p>
                    </div>
                  </Popover>
                </Col>
              </Space>
            },
          };
        case 'no': //商品编码
        case 'spec': //制剂规格
        case 'doseCategory': //剂型
        case 'genericName': //通用名
        case 'origin': //产地
        case 'hilistCode': //医保国码
        case 'batchNo': //批次号
        case 'approvalNumber': //批准文号
        case 'storehouseName': //库房名称
        case 'supplierName': //供应商
        case 'userName': //采购人员
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              const t = params.data;
              const field = item.field;
              const val = t?.[field];
              if (params.node.rowPinned) return '';
              return val ? val : '-';
            },
          };
        case 'productDate': //生产日期
        case 'deadline': //有效期至
        case 'recepitsDate': //采购时间
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
            cellRendererFramework: (params: any) => {
              const t = params.data;
              const field = item.field;
              const val = t?.[field];
              if (params.node.rowPinned) return '';
              return val
                ? moment(val).format(DateTimeFormatSimple)
                : '-'
            },
          };
        case 'count': //采购数量
          return {
            ...item,
            cellStyle: (params: any) => {
              return {
                textAlign: 'center',
                lineHeight: params.node.rowPinned ? '40px' : '56px',
              }
            },
            cellRendererFramework: function getCount(params: any) {
              const t = params.data
              return <><span>{t?.count}</span><span>{t.unit}</span></>
            },
          };
        case 'unitPrice': //进价
          return {
            ...item,
            headerClass: styles.rightAligned,
            cellStyle: (params: any) => {
              return {
                textAlign: 'right',
                lineHeight: params.node.rowPinned ? '40px' : '56px',
              }
            },
            cellRendererFramework: (params: any) => {
              const t = params.data
              const field = item.field;
              const val = Number(t?.[field]);
              return !KFGZZCKLRSJData ? '***' : (val
                ? parseFloat((val as unknown) as string).toFixed(5)
                : 0)
            },
          };
        case 'retailPrice': //销售价
          return {
            ...item,
            cellStyle: (params: any) => {
              return {
                textAlign: 'center',
                lineHeight: params.node.rowPinned ? '40px' : '56px',
              }
            },
            cellRendererFramework: (params: any) => {
              const t = params.data
              const field = item.field;
              const val = Number(t?.[field]);
              return val
                ? parseFloat((val as unknown) as string).toFixed(5)
                : 0
            },
          };
        case 'changeUnitPrice': //变动金额(进价)
          return {
            ...item,
            headerClass: styles.rightAligned,
            cellStyle: (params: any) => {
              return {
                textAlign: 'right',
                lineHeight: params.node.rowPinned ? '40px' : '56px',
              }
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned){
                if(cell?.totalChangePrice && cell?.totalChangePrice>0){
                  return cell?.totalChangePrice ;
                }else{
                  return '';
                }


              }
              const t = params.data;
              return !KFGZZCKLRSJData ? '***' : (t.unitPrice * t.count
                ? parseFloat(((t.unitPrice * t.count) as unknown) as string).toFixed(
                  2
                )
                : 0 )
            },
          };
        default:
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '56px' },
          };
      }
    })
  )
}
